import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './StopPaymentModal.module.scss';
export default function StopPaymentModal(props) {
    const { t: stopPaymentTexts } = useLocaleKeys('invoice.stopPayment');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { formattedNumber, onSubmit, dismissModal } = props;
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            reason: ''
        }
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'stop_payment_confirm'
            },
            secondaryButton: {
                name: 'stop_payment_cancel'
            }
        },
        title: stopPaymentTexts.title(),
        textAlignCenter: false,
        primaryButtonLabel: stopPaymentTexts.stopButton(),
        primaryButtonTestId: "submit-stop-payment",
        secondaryButtonLabel: commonButtons.back(),
        onSecondaryButtonClick: ()=>dismissModal(),
        onPrimaryButtonClick: handleSubmit(async (param)=>{
            let { reason } = param;
            const { success } = await onSubmit(reason.trim());
            if (success) dismissModal();
        }),
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: stopPaymentTexts.stopPaymentDescription({
                        invoiceNumber: formattedNumber
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: stopPaymentTexts.provideReasonLabel()
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "reason",
                    rules: requiredValidation(true),
                    render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                            bi: {
                                name: 'stop_payment_reason'
                            },
                            collapseHelperText: false,
                            multiline: true,
                            minRows: 6,
                            testId: "stop-payment-reason",
                            placeholder: stopPaymentTexts.placeholder()
                        }, connectControllerToTextField(renderProps)))
                })
            ]
        })
    });
}
